import s from '../styles/dashboard.module.css';

interface Props {
  taxNote: string;
}

const TaxNote = ({ taxNote }: Props) => (
  <aside className={s.taxNote}>
    <span className={s.taxNoteLabel}>Tax note</span>
    <span className={s.taxNoteBody}>{taxNote}</span>
  </aside>
);

export default TaxNote;
